// extracted by css-extract-rspack-plugin
export default {"popover":"popover-wKuUwr","popoverContent":"popoverContent-aUDmrh","icon":"icon-bFG5Ei","qrcodeContent":"qrcodeContent-k9dK_b","qrcodeImg":"qrcodeImg-jyfItj"};